import { render, staticRenderFns } from "./SystemClassificationPanel.vue?vue&type=template&id=69d665d7&"
import script from "./SystemClassificationPanel.vue?vue&type=script&lang=js&"
export * from "./SystemClassificationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports